/** Box / DB file_type prefix mapping a photorealistic render to its source preview file_id */
export const PHOTOREALISTIC_FILE_TYPE_PREFIX = "Photorealistic::";

export function isPhotorealisticFileType(fileType?: string | null): boolean {
  if (!fileType) return false;
  return fileType.startsWith(PHOTOREALISTIC_FILE_TYPE_PREFIX);
}

export function isPreviewFileType(fileType?: string | null): boolean {
  return fileType?.toLowerCase() === "ts_preview";
}

export function isPreviewOrPhotorealisticFileType(
  fileType?: string | null
): boolean {
  return isPreviewFileType(fileType) || isPhotorealisticFileType(fileType);
}

export function photorealisticFileTypeForSource(
  sourceFileId: number | string
): string {
  return `${PHOTOREALISTIC_FILE_TYPE_PREFIX}${sourceFileId}`;
}

export function sourceFileIdFromPhotorealisticType(
  fileType: string
): number | null {
  if (!fileType.startsWith(PHOTOREALISTIC_FILE_TYPE_PREFIX)) return null;
  const raw = fileType.slice(PHOTOREALISTIC_FILE_TYPE_PREFIX.length);
  const id = Number(raw.split("::")[0]);
  return Number.isFinite(id) ? id : null;
}

export function isPhotorealisticImageName(fileName: string): boolean {
  return /-(Realistic|photorealistic)(-\d+)?\.(png|jpe?g|webp|gif)$/i.test(
    fileName
  );
}
